import React, { useState, useEffect } from 'react';
import OtpInput from "react-otp-input";
import { useFormik } from 'formik';
import { UserReports } from "../../../../../apis/reports-api";
import { otpCodeValidation, login } from "../../../../../apis/login-api"; // اضافه کردن login به ایمپورت‌ها
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../../../redux/slices/login-slice";
import { useNavigate } from "react-router-dom";
import ResendCode from "./Resend-code";
import { useAuth } from "../../core/Auth";
import { reportsActions } from "../../../../../redux/slices/reports-slice";
import { toAbsoluteUrl } from '../../../../../_metronic/helpers';

function OtpCode(): JSX.Element {
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const items: any = useSelector(selectUser);
    const navigate = useNavigate();
    const { saveAuth, setCurrentUser } = useAuth();
    const dispatch = useDispatch();

    const initialValues = {
        otp_code: '',
    };

    const formik = useFormik({
        initialValues,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            try {
                const { data: auth }: any = await otpCodeValidation(otp, items.username, items.password);
                localStorage.setItem('token', auth.token);
                setLoading(false);
                if (auth.token === "00000000-0000-0000-0000-000000000000") {
                    setStatus('کد وارد شده اشتباه است');
                } else {
                    const { data }: any = await UserReports({ selectUsername: items.username }, auth.token);
                    navigate("/dashboard");
                    dispatch(reportsActions.ReportsList(data));
                }
            } catch (error) {
                saveAuth(undefined);
                setStatus('اینترنت شما دچار مشکل است');
                setSubmitting(false);
                setLoading(false);
                console.log(error);
            }
        },
    });

    const clearForm = () => {
        setOtp("");
        formik.resetForm();
    };

    useEffect(() => {
        const sendInitialOTP = async () => {
            try {
                const { data: auth }: any = await login(items.username, items.password)
                console.log(auth)
            } catch (error) {
                console.log(error)
            }
        };

        sendInitialOTP();

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                event.preventDefault(); // Prevent default form submission
                formik.handleSubmit();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [formik, items]);

    return (
        <>
            <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
                <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
                    <form
                        className='form rounded bg-body px-4 py-5 w-md-50 w-sm-75 mw-450px'
                        onSubmit={(e) => { e.preventDefault(); formik.handleSubmit(); }} // Prevent default form submission
                        noValidate>
                        <div className='w-100 d-flex justify-content-end'>
                            <button
                                type="button" // Change to type="button" to prevent form submission
                                onClick={() => navigate('/auth')}
                                className='btn btn-sm'>
                                بازگشت
                            </button>
                        </div>
                        <div className='text-center mb-11'>
                            <h1 className='text-dark fw-bolder mb-3'>کد ارسال شده را وارد کنید</h1>
                        </div>
                        {formik.status ? (
                            <div className='alert alert-danger'>
                                <div className='alert-text font-weight-bold'>{formik.status}</div>
                            </div>
                        ) : (
                            <div></div>
                        )}
                        <div dir='ltr' className="form-control border-0 bg-transparent w-100 d-flex align-items-center justify-content-center">
                            <OtpInput
                                inputStyle={{ width: '7vw', aspectRatio: '1', maxWidth: '3.5rem' }}
                                value={otp}
                                onChange={setOtp}
                                numInputs={4}
                                renderSeparator={<span><div className='px-2' /></span>}
                                renderInput={(props: any) => <input {...props} />}
                            />
                        </div>
                        <div className='d-grid mb-10'>
                            <button
                                type='submit'
                                id='kt_sign_in_submit'
                                className='btn btn-primary mt-5'
                                disabled={formik.isSubmitting || !formik.isValid}
                            >
                                {!loading && <span className='indicator-label'>ورود</span>}
                                {loading && (
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        لطفا صبر کنید...
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                )}
                            </button>
                            <ResendCode clearForm={clearForm} />
                        </div>
                    </form>
                </div>
                <div className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
                     style={{ backgroundImage: `url(${toAbsoluteUrl('/media/misc/auth-bg.png')})` }}>
                    <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
                        <h1 className='text-white fs-2qx fw-bolder text-center mb-7'>
                            آزمایشگاه ژنتیک پزشکی دکتر زینلی
                        </h1>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OtpCode;
